import React, { useState } from 'react';
import * as yup from 'yup';
import { useToast } from '../../Components/Others/ToastServices';
import { useFormik } from 'formik';

import axiosInstance from '../../Services/axiosCommon';
import { NuUpload } from '../../Components/Utils/Input'

const ImportFileModal = ({ 
  show, 
  onClose, 
  getData, 
  apiUrl, 
  menuName = "File" 
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const formik = useFormik({
    initialValues: {
      file: null,
    },
    validationSchema: yup.object({
      file: yup.mixed().required(`Please upload a File`),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      let formData = new FormData();
      formData.append('file', values.file);

      await axiosInstance.post(apiUrl, formData)
        .then(res => {
          if (res.data) {
            resetForm();
            onClose();
            getData();
            toast.open({
              type: "success",
              message: `Imported successfully`,
            });
          } else {
            setIsLoading(false);
            toast.open({
              type: "error",
              message: `Import failed`,
            });
          }
        })
        .catch(err => {
          setIsLoading(false);
          toast.open({
            type: "error",
            message: `Import failed`,
          });
        });
    }
  });

  const handleFileChange = (e) => {
    if (e.target.files.length) {
      formik.setFieldValue("file", e.target.files[0]);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
        <div className="animate-scale-in min-w-[90%] sm:min-w-[40%] max-w-[70%] max-h-[80vh] bg-white py-6 px-6 rounded-md shadow-lg overflow-y-scroll">
          <form onSubmit={formik.handleSubmit}>
            <div className="w-full">
              <NuUpload
                label={`Import  ${menuName}`}
                width="w-full"
                onChange={handleFileChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              />
              {formik.errors.file && formik.touched.file && (
                <p className="text-red-500 text-xs font-medium mt-1 ml-7">{formik.errors.file}</p>
              )}

              <div className="flex gap-4 justify-center items-baseline">
                <button
                  type="submit"
                  className={`px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm rounded-lg mt-4 text-center ${isLoading ? 'bg-red-300 cursor-wait' : 'bg-baseColor-primary'} text-white`}
                  disabled={isLoading}
                >
                  {isLoading ? `Importing...` : `Import`}
                </button>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm text-textColor-main bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ImportFileModal;
